<template>
  <base-card class="position-relative">
    <base-heading>Chat</base-heading>
    <base-button
      small
      class="position-absolute m-3 download py-2"
      style="right:0; top: 0;"
      :disabled="loading || downloadLoading || history.length === 0"
      @click="onDownloadChat"
    >
      <font-awesome-icon
        v-if="downloadLoading"
        icon="spinner"
        class="mr-2"
        spin
      />
      <base-icon
        v-else
        icon="download"
        class="mr-2"
      />
      Download Chat
    </base-button>
    <template v-if="loading">
      <div class="history__loading">
        <base-loading show />
      </div>
    </template>
    <template v-else-if="history.length === 0">
      <empty
        min-height="16.25rem"
        title="No chat on this livestream"
        style="height: 16.25rem"
      />
    </template>
    <template v-else>
      <base-text
        size="s"
        class="mb-4 pb-3 timestamp"
      >
        Sent: {{ sentDate | nicedate }}
      </base-text>
      <div class="history__wrapper">
        <template>
          <div
            v-for="(msg, index) in history"
            :key="`msg_${index}`"
            class="history d-flex justify-content-start mb-2"
          >
            <base-text
              size="s"
              class="history__sender"
            >
              {{ msg.author }}
            </base-text>
            <base-text
              size="m"
              muted
              class="history__message"
            >
              {{ msg.body }}
            </base-text>
          </div>
        </template>
      </div>
    </template>
  </base-card>
</template>

<script>
import { objectToCsv, downloadStringAsFile } from '@/_utilities/generalUseUtils';

export default {
  name: 'LivestreamChatSummary',
  props: {
    history: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      downloadLoading: false,
    };
  },
  computed: {
    sentDate() {
      if (this.history.length === 0) return '--';
      return this.$moment(this.history[0].date);
    },
  },
  methods: {
    onDownloadChat() {
      this.downloadLoading = true;
      // convert to CSV
      const { chat } = this.$store.state.appointments;
      if (!chat || chat.length === 0) return;
      const csv = objectToCsv(chat);
      const filename = `${this.$options.filters.striphtml(
        this.$store.state.appointments.item.subject,
      )}-chat.csv`;

      downloadStringAsFile(csv, filename).then(() => {
        this.downloadLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.history {
  &__sender {
    width: 31%;
    min-width: 31%;
    color: $gray-light-2;
    margin-top: 2px;
  }
  &__wrapper {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 16.25rem;
  }
  &__message {
    overflow-wrap: anywhere;
  }
  &__loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
}
.sl-card {
  height: 100%;
  ::v-deep .card-body {
    @include nested-scrollbars;
    height: 100%;
  }
}
.timestamp {
  color: $gray-light-2;
}
.download {
  ::v-deep &.base-button {
    border-color: $black !important;
    color: $black !important;
  }
}

</style>
